import React, { useState, useEffect, useContext } from "react";
import {
  Row,
  Col,
  Typography,
  Button,
  message,
  Tooltip,
  Form,
  Modal,
  Space,
  DatePicker,
  Input,
  Tag,
  List,
  Divider,
  Select,
  Card,
  Dropdown,
} from "antd";
import {
  EditOutlined,
  PlusOutlined,
  DeleteOutlined,
  MessageOutlined,
  LikeOutlined,
  DislikeOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
  UserOutlined,
  CalendarOutlined,
  MenuOutlined,
  MoreOutlined,
  UserAddOutlined,
  CopyOutlined,
} from "@ant-design/icons";
import http from "../../../../../services/http";
import dayjs from "dayjs";
import { AuthContext } from "../../../../../contexts/AuthContext";
import { ModalAvaliacao } from "../modalAvaliacao";
import { configModal } from "../../../../../components/modalConfig/config";
import { RenderDocument } from "./components/renderDocument";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ModalParticipantes } from "./components/modalParticipantes";
import { TableCustom } from "../../../../../components/table";
import { parseToInt } from "../../../../../helpers/masks";
import { ParagraphPopup } from "../../../../../components/paragraphPopup";
const { Text, Paragraph } = Typography;
const { TextArea } = Input;

const array_status = {
  [-1]: (
    <Tag icon={<DislikeOutlined />} color="error">
      Não aceito para realização
    </Tag>
  ),
  [0]: (
    <Tag icon={<CloseCircleOutlined />} color="error">
      Não alcançado
    </Tag>
  ),
  [1]: (
    <Tag icon={<CheckCircleOutlined />} color="green">
      Alcançado
    </Tag>
  ),
  [2]: (
    <Tag icon={<LikeOutlined />} color="green">
      Aceito para realização
    </Tag>
  ),
  [3]: (
    <Tag icon={<ClockCircleOutlined />} color="processing">
      Aguardando Avaliação
    </Tag>
  ),
};

const options_status = [
  {
    value: 2,
    label: "Em andamento",
  },
  {
    value: 1,
    label: "Finalizado",
  },
  {
    value: 999,
    label: "Todos",
  },
];

const array_status_text = {
  [-1]: "Não aceito para realização",
  [0]: "Não alcançado",
  [1]: "Alcançado",
  [2]: "Aceito para realização",
  [3]: "Aguardando Avaliação",
};

export const ProblemasAcoes = ({ problema, atualizarStatus }) => {
  const [form] = Form.useForm();
  const [searchParams, setSearchParams] = useSearchParams();
  const status = searchParams.get("status") ? parseToInt(searchParams.get("status")) : 999;
  const id_colaborador_responsavel = Form.useWatch("id_colaborador_responsavel", form);
  const navigate = useNavigate();
  const { session } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);
  const [modal, contextHolder] = Modal.useModal();
  const [showModal, setShowModal] = useState(false);
  const [idAlt, setIdAlt] = useState(0);
  const [colaboradores, setColaboradores] = useState([]);
  const [idAcaoParticipantes, setIdAcaoParticipantes] = useState(null);

  // AVALIAÇÃO
  const [idAvaliacao, setIdAvaliacao] = useState(0);
  const [showModalAvaliacao, setShowModalAvaliacao] = useState(false);
  const [showModalDetalhes, setShowModalDetalhes] = useState(false);
  const [acao, setAcao] = useState(null);

  useEffect(() => {
    if (problema?.id > 0) {
      listarAcoes(problema?.id);
    }
  }, [problema?.id]);

  useEffect(() => {
    listarColaboradores("");
  }, []);

  // LISTAR COLABORADORES
  const listarColaboradores = async (pesquisa_colaboradores = "") => {
    const api = await http("get", `v1/usuario/pesquisar_colaboradores?pesquisa=${pesquisa_colaboradores}`, []);
    if (api.statusCode === 200) {
      let array_colaboradores = [{ value: 0, label: "Outro" }];
      if (api.response.data) {
        api.response.data.map((col) => {
          array_colaboradores.push({
            value: col.id,
            label: `${col.matricula} - ${col.nome}`,
          });
        });
      }
      setColaboradores(array_colaboradores);
    } else {
      message.error(api.response.message);
    }
  };

  // LISTAR
  const listarAcoes = async (id) => {
    setLoading(true);
    const api = await http("get", `v1/problemas_acoes/listar/${id}`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR AÇÃO
  const cadastrarAcao = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/problemas_acoes/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      listarAcoes(problema?.id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ALTERAR AÇÃO
  const alterarAcao = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/problemas_acoes/alterar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro alterado com sucesso!");
      setShowModal(false);
      resetForm();
      listarAcoes(problema?.id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR AÇÃO
  const carregarAcao = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/problemas_acoes/carregar/${id}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      setShowModal(true);
      resetForm();

      if (response?.id_colaborador_responsavel > 0) {
        setColaboradores([
          { label: "Outro", value: 0 },
          { label: response?.colaborador_responsavel, value: response?.id_colaborador_responsavel },
        ]);
      }

      form.setFieldsValue({
        data_inicio: dayjs(response?.data_inicio ?? null),
        data_fim: dayjs(response?.data_fim ?? null),
        descricao: response?.descricao,
        nome_responsavel: response?.nome_responsavel,
        observacoes: response?.observacoes,
        id_colaborador_responsavel: response?.nome_responsavel ? 0 : response?.id_colaborador_responsavel,
      });
      setIdAlt(response?.id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR AÇÃO
  const duplicarAcao = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/problemas_acoes/carregar/${id}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      setShowModal(true);
      resetForm();

      if (response?.id_colaborador_responsavel > 0) {
        setColaboradores([
          { label: "Outro", value: 0 },
          { label: response?.colaborador_responsavel, value: response?.id_colaborador_responsavel },
        ]);
      }

      form.setFieldsValue({
        data_inicio: dayjs(response?.data_inicio ?? null),
        data_fim: dayjs(response?.data_fim ?? null),
        descricao: response?.descricao,
        nome_responsavel: response?.nome_responsavel,
        observacoes: response?.observacoes,
        id_colaborador_responsavel: response?.nome_responsavel ? 0 : response?.id_colaborador_responsavel,
      });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR AÇÃO
  const carregarAcaoDetalhes = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/problemas_acoes/carregar/${id}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      setShowModalDetalhes(true);
      setAcao(response);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR AÇÃO
  const deletarAcao = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/problemas_acoes/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarAcoes(problema?.id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
  };

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    formulario.id_problemas = problema?.id;

    // FORMAT DATE
    formulario.data_inicio = dayjs(formulario?.data_inicio).format("YYYY-MM-DD");
    formulario.data_fim = dayjs(formulario?.data_fim).format("YYYY-MM-DD");

    if (dayjs(formulario?.data_inicio) > dayjs(formulario?.data_fim)) {
      message.error("Período de datas inválido!");
      return;
    }

    if (idAlt > 0) {
      formulario.id = idAlt;
      alterarAcao(formulario);
    } else {
      cadastrarAcao(formulario);
    }
  };

  const deletarParecer = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("post", `v1/problemas_acoes/deletar_parecer`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarAcoes(problema?.id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // FORMULÁRIO
  const modalFormulario = (
    <Modal
      title={
        <Text style={{ fontSize: 20 }}>
          <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} Ação
        </Text>
      }
      open={showModal}
      onOk={() => form.submit()}
      okText="Salvar"
      width={1200}
      okButtonProps={{ size: "large", loading: loading }}
      cancelButtonProps={{ size: "large", loading: loading }}
      onCancel={() => {
        setShowModal(false);
        resetForm();
      }}>
      <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Space direction="vertical">
              <Text style={{ fontSize: 18, color: "#60b565" }} strong>
                Apontamento (O que?)
              </Text>
              <Paragraph
                className="line-break"
                ellipsis={{
                  rows: 3,
                  expandable: true,
                }}>
                {problema?.oque}
              </Paragraph>
            </Space>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Space direction="vertical">
              <Text style={{ fontSize: 18, color: "#60b565" }} strong>
                Motivo (Por que?)
              </Text>
              <Paragraph
                className="line-break"
                ellipsis={{
                  rows: 3,
                  expandable: true,
                }}>
                {problema?.porque ?? "-"}
              </Paragraph>
            </Space>
          </Col>

          <Divider />

          <Col className="gutter-row" span={24}>
            <Form.Item label="Ação" name="descricao" rules={[{ required: true, message: "Informe a ação!" }]}>
              <TextArea
                size="large"
                autoSize={{ minRows: 4, maxRows: 5 }}
                placeholder="Informe a ação"
                disabled={loading}
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="data_inicio" label="Data Início" rules={[{ required: true, message: "Informe a data!" }]}>
              <DatePicker format={"DD/MM/YYYY"} style={{ width: "100%" }} size="large" disabled={loading} />
            </Form.Item>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="data_fim" label="Data Fim" rules={[{ required: true, message: "Informe a data!" }]}>
              <DatePicker format={"DD/MM/YYYY"} style={{ width: "100%" }} size="large" disabled={loading} />
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={24}>
            <Form.Item label="Observações" name="observacoes">
              <TextArea
                size="large"
                autoSize={{ minRows: 4, maxRows: 5 }}
                placeholder="Informe as observações"
                disabled={loading}
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="id_colaborador_responsavel" label="Colaborador Responsável (Opcional)">
              <Select
                showSearch
                allowClear
                size="large"
                placeholder="Selecione o colaborador"
                disabled={loading}
                style={{ width: "100%" }}
                options={colaboradores}
                onSearch={(e) => listarColaboradores(e)}
                filterOption={false}
              />
            </Form.Item>
          </Col>

          {id_colaborador_responsavel === 0 && (
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="nome_responsavel"
                label="Nome Responsável"
                rules={[{ required: true, message: "Informe o nome do responsável!" }]}>
                <Input disabled={loading} size="large" placeholder="Informe o nome do responsável" />
              </Form.Item>
            </Col>
          )}
        </Row>
      </Form>
    </Modal>
  );

  // RENDER ITEM
  const RenderItem = ({ titulo, descricao }) => {
    return (
      <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12} style={{ marginBottom: 20 }}>
        <Space direction="vertical" size={0}>
          <Text type="secondary" style={{ fontSize: 14 }}>
            {titulo}
          </Text>
          <Text className="line-break">{descricao ?? "-"}</Text>
        </Space>
      </Col>
    );
  };

  // FORMULÁRIO
  const modalDetalhes = (
    <Modal
      title={<Text style={{ fontSize: 20 }}>Detalhes Ação</Text>}
      open={showModalDetalhes}
      width={1200}
      cancelText="Fechar"
      okButtonProps={{ style: { display: "none" } }}
      cancelButtonProps={{ loading: loading, type: "primary" }}
      onCancel={() => {
        setShowModalDetalhes(false);
        setAcao(null);
      }}>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <RenderItem titulo="Ação" descricao={acao?.descricao ?? ""} />
        <RenderItem titulo="Observações" descricao={acao?.observacoes ?? ""} />
        <RenderItem titulo="Início" descricao={dayjs(acao?.data_inicio).format("DD/MM/YYYY") ?? ""} />
        <RenderItem titulo="Fim" descricao={dayjs(acao?.data_fim).format("DD/MM/YYYY") ?? ""} />
        <RenderItem titulo="Responsável" descricao={acao?.colaborador ?? ""} />
      </Row>
    </Modal>
  );

  // COLUNAS
  const columns = [
    {
      title: "Ação (Como?)",
      dataIndex: "descricao",
      className: "fontSmall",
      width: 400,
      render: (_, e) => <ParagraphPopup text={e?.descricao} title="Ação (Como?)" />,
    },
    {
      title: "Observações",
      dataIndex: "observacoes",
      className: "fontSmall",
      width: 200,
      render: (_, e) => <ParagraphPopup text={e?.observacoes} title="Observações" />,
    },
    {
      title: "Responsável (Quem?)",
      dataIndex: "colaborador",
      className: "fontSmall",
    },
    {
      title: "Início",
      dataIndex: "data_inicio",
      className: "fontSmall",
      width: 50,
      render: (_, e) => dayjs(e?.data_inicio).format("DD/MM/YYYY"),
      renderText: (e) => dayjs(e?.data_inicio).format("DD/MM/YYYY"),
    },
    {
      title: "Fim",
      dataIndex: "data_fim",
      className: "fontSmall",
      width: 50,
      render: (_, e) => dayjs(e?.data_fim).format("DD/MM/YYYY"),
      renderText: (e) => dayjs(e?.data_fim).format("DD/MM/YYYY"),
    },
    {
      title: "Status",
      dataIndex: "status",
      className: "fontSmall",
      width: 50,
      render: (_, e) => array_status[e?.status],
      renderText: (e) => array_status_text[e?.status],
    },
    {
      title: "Ações",
      dataIndex: "acoes",
      className: "fontSmall",
      width: 80,
      sorter: false,
      render: (_, e) => {
        if (![-1, 3].includes(problema?.status)) {
          return (
            <Button
              title="Detalhes"
              loading={loading}
              onClick={() => carregarAcaoDetalhes(e.id)}
              icon={<MenuOutlined />}
            />
          );
        }

        const items = [
          ([2, 3, -1].includes(e?.status) || problema?.avaliadores?.includes(session?.usuario?.id_colaborador)) && {
            key: "1",
            label: "Parecer",
            icon: <MessageOutlined />,
            onClick: () => {
              setIdAvaliacao(e?.id);
              setShowModalAvaliacao(true);
            },
          },
          problema?.id_colaborador_atendente === session?.usuario?.id_colaborador && {
            key: "6",
            label: "Acompanhamentos",
            icon: <UserAddOutlined />,
            onClick: () => navigate(`/planos-acao/detalhes/${problema?.id}/acompanhamentos/${e?.id}`),
          },
          {
            key: "5",
            label: "Participantes",
            icon: <UserOutlined />,
            onClick: () => setIdAcaoParticipantes(e?.id),
          },
          [-1, 3, 2].includes(e?.status) &&
            [problema?.id_colaborador_atendente, problema.id_colaborador_lancamento].includes(
              session?.usuario?.id_colaborador
            ) && {
              key: "2",
              label: "Editar",
              icon: <EditOutlined />,
              onClick: () => carregarAcao(e?.id),
            },
          [problema?.id_colaborador_atendente, problema?.id_colaborador_lancamento].includes(
            session?.usuario?.id_colaborador
          ) &&
            [-1, 2, 3].includes(problema?.status) && {
              key: "3",
              label: "Duplicar",
              icon: <CopyOutlined />,
              onClick: () => duplicarAcao(e?.id),
            },
          [-1, 2, 3].includes(e?.status) &&
            [problema?.id_colaborador_atendente, problema.id_colaborador_lancamento].includes(
              session?.usuario?.id_colaborador
            ) && {
              key: "4",
              danger: true,
              label: "Excluir",
              icon: <DeleteOutlined />,
              onClick: () => {
                modal.confirm({
                  title: "Deseja deletar este registro?",
                  okText: "Sim",
                  cancelText: "Cancelar",
                  onOk() {
                    deletarAcao(e?.id);
                  },
                });
              },
            },
        ].filter((i) => i !== false);

        return (
          <Space.Compact>
            <Button
              title="Detalhes"
              loading={loading}
              onClick={() => carregarAcaoDetalhes(e.id)}
              icon={<MenuOutlined />}
            />

            {items?.length > 0 && (
              <Dropdown menu={{ items }}>
                <Button loading={loading} icon={<MoreOutlined />} />
              </Dropdown>
            )}
          </Space.Compact>
        );
      },
    },
  ];

  // CLOSE AVALIAÇÃO
  const onCloseAvaliacao = () => {
    setShowModalAvaliacao(false);
    setIdAvaliacao(0);
  };

  const modalParticipantes = (
    <ModalParticipantes id={idAcaoParticipantes} onClose={() => setIdAcaoParticipantes(null)} />
  );

  const expandedComponent = (e) => (
    <List
      style={{ paddingLeft: 30 }}
      itemLayout="horizontal"
      header={<Text strong>Pareceres</Text>}
      dataSource={e?.pareceres}
      renderItem={(item, index) => (
        <List.Item>
          <Space direction="vertical" className="full-width">
            <Space className="card-header-content full-width" size={5}>
              <Space direction="vertical" size={5}>
                <Text>
                  <UserOutlined /> {item.colaborador}
                </Text>
                <Space>
                  <Text type="secondary">
                    <CalendarOutlined /> {dayjs(item?.data_lancamento).format("DD/MM/YYYY HH:mm")}
                  </Text>
                  {array_status[item?.status_acao]}
                </Space>
              </Space>

              {item?.id_colaborador === session?.usuario?.id_colaborador &&
                item?.status !== 2 &&
                e?.pareceres?.length - 1 === index && (
                  <Button
                    type="text"
                    loading={loading}
                    onClick={() =>
                      modal.confirm({
                        ...configModal,
                        title: "Atenção",
                        content: "Deseja deletar este registro?",
                        onOk() {
                          deletarParecer(item?.id);
                        },
                      })
                    }
                    danger
                    icon={<DeleteOutlined />}
                  />
                )}
            </Space>
            {item?.parecer && (
              <Card bodyStyle={{ padding: 10 }}>
                <Text className={`fontSmall line-break ${item?.status === 2 && "text-orange"}`}>{item?.parecer}</Text>
              </Card>
            )}

            <Space wrap>
              {item?.anexos?.map((a) => (
                <RenderDocument key={a?.id} id={a?.id} name={a.nome} type={a?.formato} />
              ))}
            </Space>
          </Space>
        </List.Item>
      )}
    />
  );

  const filterData = (data, status) => {
    let dataFiltered = data;

    if (status === 1) {
      dataFiltered = dataFiltered?.filter((e) => [0, 1].includes(e?.status));
    } else if (status === 2) {
      dataFiltered = dataFiltered?.filter((e) => [-1, 2, 3].includes(e?.status));
    }

    return dataFiltered;
  };

  const filteredData = dados?.length > 0 ? filterData(dados, status) : [];

  return (
    <React.Fragment>
      {modalFormulario}
      {modalDetalhes}
      {modalParticipantes}
      <ModalAvaliacao
        onClose={onCloseAvaliacao}
        onFinish={(atualizar) => {
          listarAcoes(problema?.id);
          if (atualizar === 1 && [-1, 0, 3].includes(problema?.status)) {
            modal.confirm({
              title: "Todas as ações foram concluídas!",
              content: "Deseja alterar o status do apontamento para concluído?",
              okText: "Sim",
              cancelText: "Não",
              onOk() {
                atualizarStatus({ id: problema?.id, status: 1 });
              },
            });
          }
        }}
        avaliador={problema?.avaliadores?.includes(session?.usuario?.id_colaborador)}
        idProblema={problema?.id}
        open={showModalAvaliacao}
        id={idAvaliacao}
      />
      <Space direction="vertical" style={{ width: "100%" }}>
        <TableCustom
          rowClassName={(e) => (dayjs(e?.data_fim) < dayjs() && [-1, 2, 3].includes(e?.status) ? "danger" : "")}
          extraHeaderComponents={
            <>
              <Space direction="vertical" size={0}>
                <Text style={{ fontSize: 12 }} type="secondary">
                  Status:
                </Text>
                <Select
                  disabled={loading}
                  onChange={(val) => setSearchParams({ status: val })}
                  value={status}
                  placeholder="Selecione o status"
                  style={{ minWidth: 180 }}
                  options={options_status}
                />
              </Space>

              {[problema?.id_colaborador_atendente, problema?.id_colaborador_lancamento].includes(
                session?.usuario?.id_colaborador
              ) &&
                [-1, 3].includes(problema?.status) && (
                  <Tooltip title="Adicionar Registro">
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => {
                        setShowModal(true);
                        resetForm();
                      }}
                      loading={loading}>
                      Novo
                    </Button>
                  </Tooltip>
                )}
            </>
          }
          loading={loading}
          columns={columns}
          dataSource={filteredData}
          expandable={{
            expandIcon: ({ expanded, onExpand, record }) =>
              expanded ? (
                <Button type="primary" onClick={(e) => onExpand(record, e)}>
                  Pareceres
                </Button>
              ) : (
                <Button onClick={(e) => onExpand(record, e)}>Pareceres</Button>
              ),
            expandedRowRender: expandedComponent,
          }}
        />
      </Space>
      {contextHolder}
    </React.Fragment>
  );
};
